import actions from "actions";
import React, { Component } from "react";
import { connect } from "react-redux";
import StudyGroupUserNavigation from "../../components/StudyGroupsUser/StudyGroupUserNavigation";
import StudyGroupUserTitle from "../../components/StudyGroupsUser/StudyGroupUserTitle";

import constants from "constants";
const { CURRENT_WEBINARS } = constants;

const { getStudygroup } = actions;

const tabs = [
  { label: "Meetings", url: "/webinars/upcoming" },
  { label: "Members", url: "/members" },
  { label: "Resources", url: "/resources" },
];

class StudyGroupUserPage extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  componentWillMount() {
    this.props.loadStudyGroup(this.props.params.id);
  }

  handleClose = () => this.setState({ isOpen: false });

  render() {
    const { studygroup, params, location } = this.props;
    const groupId = params.id;

    return (
      <div>
        <main className="site--width">
          <StudyGroupUserTitle title={studygroup.title || ""} />
          <StudyGroupUserNavigation
            tabs={tabs}
            groupId={groupId}
            activeUrl={location.pathname}
          />
          {this.props.children}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.users.user.role,
  studygroup: state.studygroups.studygroup,
  current: state.webinars[CURRENT_WEBINARS],
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  loadStudyGroup: (id) => dispatch(getStudygroup(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudyGroupUserPage);



// WEBPACK FOOTER //
// ./src/containers/StudyGroups/StudyGroupUserPage.jsx